import { createSelector } from 'reselect'
import { getSoIdNumber } from '../../../helpers'
import {
	selectFilteredPositionsAssetsSoId
} from '../positions/selectors'

export const selectDefaultAssets = (state) => state.appReducer.assets.defaultAssets || null
export const selectAssetsSoIdesAll = (state) => state.appReducer.assets.assetsSoIdesAll || null
export const selectAssetTime = (type, key) => (state) => state.appReducer.assets.assetsAll[type][key]?.time || ''
export const selectPipDecimalPlaces = (type, key) => (state) =>
	state.appReducer.assets.assetsAll[type][key]?.pipDecimalPlaces || 0
export const selectAssetTailDigits = (type, key) => (state) => state.appReducer.assets.assetsAll[type][key]?.tailDigits
export const selectAssetTitle = (type, key) => (state) =>  state.appReducer.assets.assetsAll[type][key].title || ''
export const selectAssetAlias = (type, key) => (state) =>  state.appReducer.assets.assetsAll[type][key].alias || ''
export const selectAssetMuted = (type, key) => (state) =>  state.appReducer.assets.assetsAll[type][key].muted || false
export const selectAssetNearestStart = (type, key) => (state) =>
	state.appReducer.assets.assetsAll[type][key].nearestStart || ''
export const selectAssetId = (type, key) => (state) => state.appReducer.assets.assetsAll[type][key].id || ''
export const selectAssetSoId = (type, key) => (state) => state.appReducer.assets.assetsAll[type][key].soId || ''
export const selectAssetBookmarked = (type, key) => (state) =>
	state.appReducer.assets.assetsAll[type][key]?.bookmarked || ''
export const selectAssets = (state) => state.appReducer.assets.assetsList || []
export const selectAssetsFilter = (state) => state.appReducer.assets.assetFilter || ''
export const selectSelectedAsset = (state) => state.appReducer.assets.selectedAsset || ''
export const selectAssetsToSockets = (state) => state.appReducer.assets.assetsToSockets || []
export const selectAssetSearchString = (state) => state.appReducer.assets.assetSearchString || ''
export const selectAssetSingle = (state) => state.appReducer.assets.assetSingle || null
export const selectMutedAssets = (state) => state.appReducer.assets.mutedAssets || []
export const selectSelectedAssetTitle = (state) => state.appReducer.assets.selectedAssetTitle || []
export const selectLatestRatesBidAsk = (key) => (state) => state.appReducer.assets.latestRatesBidAsk[key] || null
export const selectMainConversionAssets = (state) => state.appReducer.assets.latestRatesBidAsk || undefined
export const selectOnlyFavorite = (state) => state.appReducer.assets.onlyFavorite
export const selectClassAssetsTypes = (state) => state.appReducer.assets.classAssetsTypes
export const selectClassAssetsTypesDefault = (state) => state.appReducer.assets.classAssetsTypesDefault
export const selectLatestRatesItem = (key) => (state) => state.appReducer.assets.latestRates?.[key] || undefined
export const selectLotSize = (key) => (state) => state.appReducer.assets.lotSizes?.[key] || null
export const selectActiveHours = (key) => (state) => state.appReducer.assets.activeHoursArr?.[key] || null

export const selectDefaultAssetInfo = createSelector(
	[
		selectDefaultAssets, selectSelectedAsset],
	(assetsArr, selectedAsset) => {
		return assetsArr.find(asset => asset.soId === getSoIdNumber(selectedAsset.assetSoId))
	}
)
export const selectAllAssetsToSocket = createSelector(
	[
		selectAssetsToSockets,
		selectMutedAssets,
		selectFilteredPositionsAssetsSoId,
		selectSelectedAsset
	],
	(
		assetsToSockets,
		mutedAssets,
		positionsToSockets,
		selectedAsset
	) => {
		const newAssetsToSockets = assetsToSockets.filter(assetSoId => !mutedAssets.includes(assetSoId.split('_')[1]))
		const result = newAssetsToSockets.concat(positionsToSockets, [selectedAsset?.assetSoId])
		if (!result[0]) return []
		return Array.from(new Set(
			newAssetsToSockets.concat(positionsToSockets,
				['asset_91', 'asset_137', 'asset_35', 'asset_95', 'asset_139', 'asset_4121', 'asset_4149'],
				[selectedAsset?.assetSoId]
			)))
	}
)

export const selectAssetsCurrentList = createSelector(
	[
		selectAssets,
		selectAssetsFilter
	],
	(
		assets,
		searchStr,
		toUpdateAsset,
		checkedAssetsTypes
	) => {
		checkedAssetsTypes = ''
		if (assets.length){
			return ((
				assets.filter(asset => {
					if (!searchStr) return true
					return (
						asset.type.includes(searchStr)
					)
				})
					.map(asset => {
						if (
							checkedAssetsTypes.length &&
							checkedAssetsTypes.every(checkType => !asset.type.includes(checkType))
						) {
							return null
						}
						return {
							ask: asset.lastAsk,
							bid: asset.lastBid,
							id: asset.id,
							soId: asset.soId,
							title: asset.name,
							type: asset.type
						}
					})
					.filter(c => !!c)) || []
			)
		}
	}
)

export const selectSearchAssets = createSelector(
	[
		selectDefaultAssets,
		selectAssetSearchString,
		selectOnlyFavorite
	],
	(
		assets,
		string,
		onlyFavorite

	) => {
		let result = []
		if (onlyFavorite) assets = assets.filter(item => item.bookmarked)
		if (string && string.length) assets = assets.filter(item =>
			item.name.toLowerCase().includes(string.toLowerCase()))
		if(assets && assets.length) assets.forEach(asset => result.push(
			{'assetName': asset.name, 'assetSoId': 'asset_' + asset.soId, 'assetType': asset.type }
		))
		return result
	}
)

export const selectSearchAssetsSoIdesAll = createSelector(
	[
		selectAssetsSoIdesAll,
		selectSearchAssets
	],
	(
		assetsSoIds,
		assetsArr
	) => {
		let result = {}
		if (assetsArr && assetsArr.length){
			let assetsSoIdsArr = []
			assetsArr.forEach(item => assetsSoIdsArr.push(item.assetSoId))
			let type
			for(type in assetsSoIds) {
				if (!result[type]) result[type] = []
				result[type] = assetsSoIds[type].filter(assetSoId => assetsSoIdsArr.includes(assetSoId))
			}
			return result
		}
	}
)

